/** @jsxImportSource @emotion/react */
import { createContext, useContext } from 'react'
import { useDispatch } from 'react-redux'

import { ClearMapProps } from './PropertyMapContext.types'
import { updateMapStateProperty } from '@app/redux/prioritisationMap/prioritisationMapSlice'
import {
  GenericMapContextInterface,
  MapProviderProps,
} from '../GenericMapContext/GenericMapContext.types'
import { useGenericMapContext } from '../GenericMapContext'

export type PropertyMapContext = GenericMapContextInterface

export const PropertyMapContext = createContext({} as PropertyMapContext)

export function PropertyMapProvider({ children }: MapProviderProps) {
  const dispatch = useDispatch()
  const genericMapContext = useGenericMapContext()

  const clearMap = ({ map }: ClearMapProps) => {
    if (!map) return

    genericMapContext.clearMap({ map })
    dispatch(updateMapStateProperty({ layers: [] }))
  }

  return (
    <PropertyMapContext.Provider
      value={{
        ...genericMapContext,
        clearMap,
      }}
    >
      {children}
    </PropertyMapContext.Provider>
  )
}

export const usePropertyMap = () => useContext(PropertyMapContext)
